import { Alert } from "@mui/material";
import { useQuery } from "react-query";
import { Route, Routes, useParams } from "react-router-dom";
import React from "react";
import ActionLoader from "../../components/UI/ActionLoader/ActionLoader";
import { Feature } from "../../models/api";
import { fetchServices } from "../../framework/services";
import { Resources } from "constants/enums";
import Users from "Pages/Users";
import Policies from "Pages/Policies";
import Faqs from "Pages/Faqs";
import Questions from "Pages/Questions";
import DoctorDetails from "Pages/DoctorDetails";
import UserDetails from "Pages/UserDetails";
import Goals from "Pages/Goals";
import Faqs2 from "Pages/Faqs2";
import ChangePassword from "components/UI/ChangePassword";
import AboutUs from "Pages/AboutUs";
import QUsers from "Pages/EConsultationUsers";
import QUsersDetails from "Pages/EConsultationUsersDetails";
import TreatmentDetails from "Pages/TreatmentsDetails";
interface Props { }

const Listing: React.FC<Props> = () => {
  let { slug } = useParams<{ slug: string }>();
  const { data, isError, isLoading } = useQuery<Feature[]>(
    "features",
    fetchServices
  );
  if (isLoading) return <ActionLoader position="fixed" />;
  if (isError)
    return (
      <Alert severity="error">
        Something went wrong, please try again later.
      </Alert>
    );
  let feature: Feature | undefined = data?.find(
    (feature) =>
      feature.slug === slug ||
      feature.children.some((child) => child.slug === slug)
  );
  if (feature?.children?.length! > 0)
    feature = feature?.children.find((child) => child.slug === slug);
  if (!feature) return <Alert severity="error">404 - Page not found</Alert>;


  const renderEditForm = () => {
    if (!feature) return null;
    if (feature.slug === Resources.USERS) return <UserDetails feature={feature} />;
    if (feature.slug === Resources.DOCTORS) return <DoctorDetails feature={feature} />;
    if (feature.slug === Resources.ECONSULTATION_USERS) return <QUsersDetails feature={feature} />;
    if (feature.slug === Resources.Treatments) return <TreatmentDetails feature={feature} />;
  };

  const renderList = () => {
    if (!feature) return null;
    if (feature.slug === Resources.USERS) return <Users userId="1" feature={feature} />;
    if (feature.slug === Resources.DOCTORS) return <Users userId="2" feature={feature} />;
    if (feature.slug === Resources.POLICIES) return <Policies feature={feature} />;
    if (feature.slug === Resources.FAQS) return <Faqs2 feature={feature} />;
    if (feature.slug === Resources.QUESTIONS) return <Questions feature={feature} />;
    if (feature.slug === Resources.GOALS) return <Goals feature={feature} />;
    if (feature.slug === Resources.ABOUT_US) return <AboutUs feature={feature} />;
    if (feature.slug === Resources.ECONSULTATION_USERS) return <QUsers feature={feature} />;
    if (feature.slug === Resources.UPDATE_PASSWORD) return <ChangePassword />;

  };

  return (
    <>
      <Routes>
        <Route path="/*" element={renderList()} />
        {/* <Route path="new" element={renderCreateForm()} /> */}
        <Route path={`:${feature.singleName}Id/*`} element={renderEditForm()} />
      </Routes>
    </>
  );
};

export default Listing;
